/*
 * (c) Copyright, 2026, Medidata Solutions Worldwide, Inc. All rights reserved.
 *
 * EOS Export In Process Modal
 *
 * Migrated from: lego/page/eos/overview/StatusDocuments/ExportInProcessModal.jsx
 */

import { useState } from 'react'
import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import Modal from '~/components/Modal'

const ExportInProcessModal: React.FC = () => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(true)

  const doClose = () => {
    setIsOpen(false)
  }

  if (!isOpen) return null

  return (
    <Modal
      show={isOpen}
      handleClose={doClose}
      id="modal-add-file"
      className="theme-sandman"
      title={t('EXPORT_IN_PROCCESS_TITLE')}
    >
      <Modal.Body className="fs12 mb10">{t('EXPORT_IN_PROCCESS_TEXT')}</Modal.Body>
      <Modal.Footer>
        <div className="text-right">
          <Button className="btn btn-primary text-capitalize" onClick={doClose}>
            {t('OK')}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default ExportInProcessModal
